import {publishEvent} from '../pub-sub';
import {ANALYTIC_EVENTS} from '../pub-sub/constants';

export const RefreshTokenTracker = {
  onSuccess: () => publishEvent(ANALYTIC_EVENTS.REFRESH_TOKEN_SUCCESS),
  onError: error_message => publishEvent(ANALYTIC_EVENTS.REFRESH_TOKEN_ERROR, {
    errorMessage: error_message
  })
};
